import {Controller} from "stimulus"

export default class extends Controller {

    connect() {
        console.log("hello from reportsCashflowPayouts");
    }

    updateReport(e) {
        console.log("report changed")
        const reportDateSelect = document.getElementById("payout_id")
        const selectedOption = reportDateSelect.options[reportDateSelect.selectedIndex]
        const dateText = selectedOption.text
        const title = "Payouts: " + dateText;
        window.location.href = 'chart?title=' + title + '&data_source=reports_cashflow_payouts_path&chart_type=pie_chart&date=' + reportDateSelect.value;
    }
}